import { onError } from '@apollo/client/link/error';
import { isBrowser, WEBAPP_ROUTE_PREFIX } from '~/constants';
import { callRefreshToken } from '~/helpers/legacy-server-functions';
import { getToken, isTokenExpired } from '~/helpers/token';

const errorLink = onError(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    ({ graphQLErrors, operation, forward, networkError }) => {
        if (networkError) {
            console.error(
                'CONNECTION FAILED: Are you connected to the internet?'
            );
            return;
        }

        graphQLErrors?.forEach(async (error) => {
            const originalError = error?.extensions?.originalError as {
                statusCode: number;
                message: string;
            };
            const hasuraErrorCode = error?.extensions?.code;

            if (
                originalError?.statusCode === 401 ||
                hasuraErrorCode === 'invalid-jwt'
            ) {
                if (isBrowser) {
                    const token = getToken();
                    if (isTokenExpired(token)) {
                        try {
                            const newToken = await callRefreshToken();

                            if (!newToken) {
                                throw new Error('Failed to refresh token');
                            }

                            const context = operation.getContext();

                            operation.setContext({
                                ...context,
                                headers: {
                                    ...context.headers,
                                    Authorization: `Bearer ${newToken}`,
                                },
                            });

                            return forward(operation);
                        } catch {
                            // pass
                            // user will be logged out
                        }
                    }
                    window.location.replace(`${WEBAPP_ROUTE_PREFIX}/logout`);
                }
            } else {
                console.error(error);
            }

            if (error?.extensions?.code === 'INTERNAL_SERVER_ERROR') {
                console.error('INTERNAL_SERVER_ERROR');
            } else if (error?.extensions?.code === 'FORBIDDEN') {
                console.error(error?.message);
            }
            return null;
        });
    }
);

export default errorLink;
